import { setFileMode } from '../State/filemode';

export default () => async (dispatch) => {
  
  dispatch(setFileMode('list'));
  
}